import React, { useState } from "react"
import "./database-exports.scss"

// UI imports
import Tile from "../../components/structure/tile/tile"
import Title from "../../components/structure/title/title"
import Navigation from "../../components/ui/navigation/navigation"

// Tabs
import SupplierAudit from "./_tabs/supplier-audit"
import BookingExport from "./_tabs/booking-export"
import BookingSuppliers from "./_tabs/booking-suppliers"
import CmsCatalogue from "./_tabs/cms-catalogue"

/**
 * Hidden, admin-only "Database Exports" page. A tabbed shell hosting the
 * different export tools:
 *   - Supplier audit: the Golfbreaks supplier audit workbook
 *   - Booking export: each booking's supplier lines with a margins total
 *   - Booking suppliers: hotels/courses/transfers attached to bookings
 *   - CMS holidays & courses: the website CMS catalogue
 */
export default function DatabaseExports() {
	const [activeTab, setActiveTab] = useState("SUPPLIER_AUDIT")

	return (
		<Tile fullPage={true}>
			<Title className="flex has-select-field">
				<h1>Database Exports</h1>
			</Title>

			{/* Tabbed navigation between the export tools */}
			<Navigation
				links={[
					{ id: "SUPPLIER_AUDIT", label: "Supplier audit" },
					{ id: "BOOKING_EXPORT", label: "Booking export" },
					{ id: "BOOKING_SUPPLIERS", label: "Booking suppliers" },
					{ id: "CMS_CATALOGUE", label: "CMS holidays & courses" },
				]}
				active={activeTab}
				onClick={(tabID) => setActiveTab(tabID)}
			/>

			<div className="db-exports-tab-content">
				{activeTab === "SUPPLIER_AUDIT" && <SupplierAudit />}
				{activeTab === "BOOKING_EXPORT" && <BookingExport />}
				{activeTab === "BOOKING_SUPPLIERS" && <BookingSuppliers />}
				{activeTab === "CMS_CATALOGUE" && <CmsCatalogue />}
			</div>
		</Tile>
	)
}
